const messages = {
    error_bitcoin: 'Personal information',
    save: 'Save',
};

export default messages;
